<template>
  <v-container>
    <v-layout>
      <v-flex class="text-xs-right">
        <v-btn color="primary" outline @click="showAdd = true">
          <v-icon class="mr-2">add</v-icon>
          {{ $t('Add') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="text-xs-center py-5" v-if="branches.length == 0">ไม่มีที่อยู่ร้านค้า</div>
    <template v-else v-for="(shop, index) in branches">
      <v-card class="mb-2" :key="`${shop.name}_${index}`">
        <v-card-text>
          <v-layout>
            <v-flex>
              <div class="title mb-2 primary--text">
                {{ shop.name }}
              </div>
              {{ shop.address }}
              <div class="caption mt-1">
                {{ shop.tel }}
              </div>
              <div class="caption mt-1 grey--text">{{ shop.lat }}, {{ shop.long }}</div>
              <!-- <v-chip
                class="white--text"
                :color="shop.type == 'Workshop' ? 'success' : 'warning'"
                small
                disabled
                >{{ shop.type == 'Workshop' ? 'ศูนย์บริการ' : 'ร้านอะไหล่' }}</v-chip
              > -->
            </v-flex>
            <v-flex shrink>
              <v-btn
                fab
                small
                outline
                class="my-0"
                @click="
                  currentIndex = index
                  currentBranch = shop
                  showEdit = true
                "
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn fab small outline class="my-0" @click="deleteBranch(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>

    <!-- <manage-branch-location v-model="showAdd" @onSave="addBranch"></manage-branch-location>
    <template v-if="currentBranch">
      <manage-branch-location
        v-model="showEdit"
        :currentbranch="currentBranch"
        @onSave="editBranch"
      ></manage-branch-location>
    </template> -->

    <ModalShippingAddress v-model="showAdd" @onSave="addBranch"></ModalShippingAddress>
    <template v-if="currentBranch">
      <ModalShippingAddress
        v-model="showEdit"
        :currentbranch="currentBranch"
        @onSave="editBranch"
      ></ModalShippingAddress>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
// import ManageBranchLocation from '@/components/view/dashboard/ManageBranchLocation.vue'
import ModalShippingAddress from '@/components/view/template/foodguru/ModalShippingAddress'
import api from '@/api'
export default {
  data() {
    return {
      branches: [],
      showAdd: false,
      showEdit: false,
      currentIndex: null,
      currentBranch: null
    }
  },
  components: {
    // ManageBranchLocation,
    ModalShippingAddress
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    var response = await this.getbranchlocation()
    if (response.responsecode == 200) {
      if (response.branchlocation) {
        // console.log(response.branchlocation)
        try {
          this.branches = response.branchlocation
        } catch (error) {
          this.branches = []
        }
      }
    }
  },
  methods: {
    async addBranch(payload) {
      this.branches.push(payload)
      this.showAdd = false
      await this.savebranchlocation()
    },
    async editBranch(payload) {
      this.$set(this.branches, this.currentIndex, payload)
      this.showEdit = false
      this.currentIndex = null
      this.currentBranch = null
      await this.savebranchlocation()
    },
    async deleteBranch(index) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: ''
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.branches.splice(index, 1)
        await this.savebranchlocation()
      }
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getbranchlocation({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }

          resolve(response)
        })
      })
    },
    savebranchlocation() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.savebranchlocation(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              branchlocation: JSON.stringify(vm.branches)
            }
          },
          (error, response) => {
            if (error) {
              console.error(error)
              reject(error)
            }

            resolve(response)
          }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/foodguru/ShippingAddress.vue